<script>
import { ValidationProvider } from 'vee-validate';
import { GlFormCheckbox, GlLink, GlSprintf, GlFormGroup } from '@gitlab/ui';
import validationStateMixin from '~/javascripts/forms/validation/mixins/validation_state_mixin';
import { __ } from '~/javascripts/lib/locale';

export const i18n = Object.freeze({
  PRIVACY_POLICY_LINK: 'https://gitlab.cn/privacy/',
  TERMS_OF_USE_LINK: 'https://gitlab.cn/terms/#subscription', // keep this jh
  PRIVACY_AND_TOS_TEXT: `${__('I accept the')} %{privacyLinkStart}${__('Privacy Statement')}%{privacyLinkEnd}
  ${__('and')} %{termsOfServiceLinkStart} ${__('Terms of Service.')} %{termsOfServiceLinkEnd}`,
  TERMS_VALIDATION_MESSAGE: 'You must accept the terms to continue.',
});

export default {
  name: 'AcceptTerms',
  components: {
    GlLink,
    GlSprintf,
    GlFormGroup,
    GlFormCheckbox,
    ValidationProvider,
  },
  mixins: [validationStateMixin],
  props: {
    validationEnabled: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      areTermsAccepted: false,
    };
  },
  computed: {
    validationRules() {
      return this.validationEnabled ? { required: { allowFalse: false } } : {};
    },
    validationMessages() {
      return {
        required: i18n.TERMS_VALIDATION_MESSAGE,
      };
    },
  },
  methods: {
    change(value) {
      this.$emit('change', value);
    },
  },
  i18n,
};
</script>

<template>
  <validation-provider
    #default="validationContext"
    :rules="validationRules"
    :custom-messages="validationMessages"
    slim
  >
    <gl-form-group
      class="gl-mb-0 gl-mt-6"
      label-class="!gl-m-0 !gl-p-0"
      :invalid-feedback="validationContext.errors[0]"
      :state="getValidationState(validationContext)"
    >
      <gl-form-checkbox id="acceptTerms" v-model="areTermsAccepted" @change="change">
        <gl-sprintf :message="$options.i18n.PRIVACY_AND_TOS_TEXT">
          <template #privacyLink="{ content }">
            <gl-link
              data-testid="privacy-link"
              :href="$options.i18n.PRIVACY_POLICY_LINK"
              target="_blank"
              class="gl-text-blue-600"
              >{{ content }}</gl-link
            >
          </template>
          <template #termsOfServiceLink="{ content }">
            <gl-link
              data-testid="terms-link"
              :href="$options.i18n.TERMS_OF_USE_LINK"
              target="_blank"
              class="gl-text-blue-600"
              >{{ content }}</gl-link
            >
          </template>
        </gl-sprintf>
      </gl-form-checkbox>
    </gl-form-group>
  </validation-provider>
</template>
